$(function() {

  gsap.registerPlugin(ScrollTrigger);

  $('[data-mh]').matchHeight();
  $('[data-mhnr]').matchHeight({byRow: false});



  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
  document.documentElement.style.setProperty('--actualvw-width', 'calc(100vw - var(--scrollbar-width))');

  $(window).bind('load resize', function(){
    var wrapperWidth = $('.wrapper').outerWidth() - 40;

    document.documentElement.style.setProperty('--wrapperWidth', wrapperWidth+'px');

  });


  $('.advisory-wrap.no-desktop .single-txt').matchHeight();

  // NO HEIGHT RESIZE ON MOBILE
    if ($('html').is('.touchevents, .mobile, .tablet') ) {
      $('[data-pxht]').each(function(index) {
        var pxHeight =  $(this).height();
        $(this).css('height', pxHeight+'px');
      });
    } else {
      $(window).bind('load resize', function(){
        $('[data-pxht]').each(function(index) {
          $(this).removeAttr('style');
          var pxHeight =  $(this).height();
          $(this).css('height', pxHeight+'px');
        });
      });
    }



  $('a.fnbtn[onclick]').click(function(e) {
    e.preventDefault();
  });


  // HEADER DROPDOWNS
    $('.header--has-menu [data-menu]').each(function(index) {

      var drpLink = $(this);

      var theNav = drpLink.attr('data-menu');

      var navMenu = $('.menu-dropdown#menu-'+theNav);

      // drpLink.append('<i class="_pcicon-chevron"></i>');


      drpLink.on('click', function(e) {
        e.preventDefault();

        if($(this).parents('li').hasClass('is-hover')) {

          $(this).parents('.header--menu').removeClass('has-hover');

          $(this).parents('li').removeClass('is-hover');
          navMenu.removeClass('dropdown-open');
          $('body').removeClass('menudropdown-open');
          $('body').removeClass('nav-hovered');

        } else {

          $(this).parents('.header--menu').addClass('has-hover');

          $(this).parents('li').addClass('is-hover');
          navMenu.addClass('dropdown-open');
          $('body').addClass('menudropdown-open');
          $('body').addClass('nav-hovered');

        }

        if($(this).parents('li').siblings('li').hasClass('is-hover')) {
          var wasMenu = $(this).parents('li').siblings('li.is-hover').find('a').attr('data-menu');
          var wasHover = $(this).parents('li').siblings('li.is-hover');
          wasHover.removeClass('is-hover');

          $('.menu-dropdown#menu-'+wasMenu).removeClass('dropdown-open');

        }

      });


    });

    $('.menubg').click(function(event){
      $('.header--menu.has-hover').removeClass('has-hover');
      $('[data-menu]').parents('li.is-hover').removeClass('is-hover');
      $('.menu-dropdown').removeClass('dropdown-open');
      $('body').removeClass('menudropdown-open');
      $('body').removeClass('nav-hovered');
    });



  // HERO SIZING
    if($('.fnsection-fullhero').length) {

      if ($('html').is('.touchevents, .mobile, .tablet') ) {

        if($('#shopify-section-fn-announcement-bar').length) {

          var topbarHt = $('#shopify-section-fn-announcement-bar').outerHeight();
          var windowHeight = $(window).height();

          var headerHt = $('header.header').outerHeight();
          var topbarHt = topbarHt + headerHt;

          var windowHeight = windowHeight - topbarHt;



          $('.fnsection-fullhero .hero-wrap').css('height', windowHeight+'px');

        }

      } else {
        $(window).bind('load resize', function(){
          // var windowHeight = $(window).height();

          var topbarHt = $('#shopify-section-fn-announcement-bar').outerHeight();
          var windowHeight = $(window).height();

          var headerHt = $('header.header').outerHeight();
          var topbarHt = topbarHt + headerHt;

          var windowHeight = windowHeight - topbarHt;



          $('.fnsection-fullhero .hero-wrap').css('height', windowHeight+'px');
        });
      }

    }


    if($('.fnsection-fullhero').length || $('.fnsection-halfhero').length ) {
      // getHeroHeight();

      // $('body').addClass('has-hero');

      // $(window).resize(function() {

      //   window.setTimeout(function () {
      //     getHeroHeight();
      //   }, 100);

      // });
    }


    function getHeroHeight() {

      var topbarHt = 0;
      var headerHt = $('header.header').outerHeight();

        if($('#shopify-section-fn-announcement-bar').length) {
          $('body').addClass('has-topbar');
          topbarHt = $('#shopify-section-fn-announcement-bar').outerHeight();
        }

        var totalHt = headerHt * -1;

        // $('.fnsection-hero .hero-wrap').css('margin-top', totalHt+'px');

    }



  // SLICK

    if($('.annbar-slider').length) {

      $(".fn-annbar .annbar-slider").not('.slick-initialized').slick({
        fade: true,
        speed: 250,
        cssEase: 'ease',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000
      });

    }


    $(".fnsection-prodfeature .feature-slider").not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: '.feature-buttons',
      prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
      nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
      fade: false,
      dots: false,
      centerMode: true,
      centerPadding: '0px',
      infinite: true,
      autoplay: false,
      asNavFor: '.ftslider-nav'
    });

    $(".fnsection-prodfeature .feature-nav").not('.slick-initialized').slick({
      fade: true,
      speed: 250,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.ftslider-for',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      appendArrows: '.nav-buttons',
      prevArrow: '<button class="slide-prev"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 18L7.91992 10.9687L14 4.31982" stroke="#099157" stroke-width="2"/></svg></button>',
      nextArrow: '<button class="slide-next"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4L14.0801 11.0313L8 17.6802" stroke="#099157" stroke-width="2"/></svg></button>'
    });



    // $(".cardslider").each(function(key, item) {

    //   $(this).not('.slick-initialized').slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    //     appendArrows: $(this).next('.cardslider-buttons'),
    //     prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
    //     nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
    //     fade: false,
    //     dots: false,
    //     infinite: false,
    //     autoplay: false,
    //     responsive: [
    //       {
    //         breakpoint: 990,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 2
    //         }
    //       }, {
    //         breakpoint: 750,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    //   });

    // });

      $('.cardslider').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        appendArrows: $('.cardslider').next('.cardslider-buttons'),
        prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        fade: false,
        dots: false,
        infinite: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });


      $('.advisoryslider').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        appendArrows: $('.advisoryslider').next('.cardslider-buttons'),
        prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        fade: false,
        dots: false,
        infinite: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });


      $('.teamslider').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        appendArrows: $('.teamslider').next('.cardslider-buttons'),
        prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
        fade: false,
        dots: false,
        infinite: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

    // PRODUCT PAGE IMAGES
    $('.prodimgs-slider').on('init',function(){
      $('[data-slick-index="0"]').nextAll().addClass('nextdiv');

      window.setTimeout(function () {
        $('.prodimgs-slider').addClass('slider-ready');
      }, 250);

    });




    $(".prodimgs-slider").not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: '.prodimgs-buttons',
      prevArrow: '<button class="slide-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 0.720258 0.693706 0.720258 22 7)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(-0.693706 -0.720258 0.693706 -0.720258 22 29)" stroke="#006C3E" stroke-width="2"/></svg></button>',
      nextArrow: '<button class="slide-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 -0.720258 -0.693706 -0.720258 14 29)" stroke="#006C3E" stroke-width="2"/><line y1="-1" x2="17.2972" y2="-1" transform="matrix(0.693706 0.720258 -0.693706 0.720258 14 7)" stroke="#006C3E" stroke-width="2"/></svg></button>',
      fade: false,
      dots: false,
      infinite: false,
      autoplay: false,
    });

    $('.prodimgs-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('[data-slick-index="'+nextSlide+'"]').removeClass('nextdiv');
      $('[data-slick-index="'+nextSlide+'"]').nextAll().addClass('nextdiv');
    });

    $('.prodimgs-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){

      $('[data-slick-index="'+currentSlide+'"]').prevAll().removeClass('nextdiv');
      $('[data-slick-index="'+currentSlide+'"]').nextAll().addClass('nextdiv');

    });




  // LIST ITEM HOVER

    // NO TOUCH EVENTS
    if($('.fnsection-hoverlist').length && $('html').hasClass('no-touchevents')) {

      $('.fnsection-hoverlist:not(.fnsection-hoverlist-alt) .item-text').each(function(index) {
        $(this).show();
      });

      $(window).mousemove(function(e) {

        var winHt = $(window).height();
        var winWd = $(window).width();

        var winbot = winHt * .65;
        var winright = winWd - 520;

        $('.item-text').css('top', (e.clientY + 20)+'px').css('left', (e.clientX + 20)+'px');

        if(e.clientY > winbot) {
          $('.item-text').addClass('near-bottom');
        } else {
          $('.item-text').removeClass('near-bottom');
        }

        if(e.clientX > winright) {
          $('.item-text').addClass('near-right');
        } else {
          $('.item-text').removeClass('near-right');
        }


      }).mouseover();


      $('.hoverlist-item > a').hover(function(e) {
        e.preventDefault();

        $(this).next().toggleClass('item-active');

      });


      $('.fnsection-hoverlist:not(.fnsection-hoverlist-alt) .hoverlist-item > a').click(function(e) {
        e.preventDefault();


      });


    }

    // TOUCH EVENTS
    if($('.fnsection-hoverlist').length && $('html').hasClass('touchevents')) {

      $('.fnsection-hoverlist:not(.fnsection-hoverlist-alt) .item-text').each(function(index) {
        $(this).hide();
      });

      $('.fnsection-hoverlist:not(.fnsection-hoverlist-alt) .hoverlist-item > a').click(function(e) {
        e.preventDefault();

        $(this).parents('.hoverlist-item').toggleClass('item-open');
        $(this).next().toggle();

      });

      $('.fnsection-hoverlist.fnsection-hoverlist-alt .hoverlist-item > a').click(function(e) {
        e.preventDefault();

        $(this).next().addClass('item-active');


      });

      $('.fnsection-hoverlist.fnsection-hoverlist-alt .hoverlist-item [data-hoverclose]').click(function(e) {
        e.preventDefault();

        $(this).parents('.item-text').removeClass('item-active');


      });

    }



  // SHOW
    if($('[data-show]').length) {

      var winWid = $(window).width();

      $('[data-show]').each(function(index) {

        var showWid = $(this).attr('data-show');

        if(winWid >= showWid) {
          $(this).next().show()
        } else {
          $(this).next().hide()
        }

      });

      $(window).bind('resize', function(){
        var winWid = $(window).width();

        $('[data-show]').each(function(index) {

          var showWid = $(this).attr('data-show');

          if(winWid >= showWid) {
            $(this).next().show()
          } else {
            $(this).next().hide()
          }

        });
      });


      $('[data-show]').click(function(e) {
        e.preventDefault();

        $(this).next().toggle();

      });


    }




  // BEFORE AFTER SLIDER

    if($('#ba-slider').length) {

      var pxWidth =  $('.ba-cont').outerWidth();
      $('.ba-image').each(function(index) {
        $(this).css('width', pxWidth+'px');
      });

      $(window).bind('resize', function(){
        $('.ba-image').removeAttr('style');
        var pxWidth =  $('.ba-cont').outerWidth();
        $('.ba-image').each(function(index) {
          $(this).css('width', pxWidth+'px');
        });
      });




      $('.ba-slider-wrap').each(function(){

        var ht;

        window.setTimeout(function () {
          var elementHeights = $('.ba-text .inner').map(function() {
            return $(this).outerHeight();
          }).get();
          var ht = Math.max.apply(null, elementHeights);
          $('.ba-text').height(ht);
          $('.ba-image').css('padding-bottom', ht+'px');
        }, 10);

        $(window).bind('resize', function(){
          window.setTimeout(function () {
            var elementHeights = $('.ba-text .inner').map(function() {
              return $(this).outerHeight();
            }).get();
            var ht = Math.max.apply(null, elementHeights);
            $('.ba-text').height(ht);
            $('.ba-image').css('padding-bottom', ht+'px');
          }, 10);
        });

      });



      $('.ba-cont').each(function(){

        var ht;

        window.setTimeout(function () {
          var elementHeights = $('.ba-image').map(function() {
            return $(this).outerHeight();
          }).get();
          var ht = Math.max.apply(null, elementHeights);
          $('.ba-cont').height(ht);
        }, 100);

        $(window).bind('resize', function(){
          window.setTimeout(function () {
            var elementHeights = $('.ba-image').map(function() {
              return $(this).outerHeight();
            }).get();
            var ht = Math.max.apply(null, elementHeights);
            $('.ba-cont').height(ht);

          }, 100);
        });

      });


      if($(window).width() >= 990) {
        $("#ba-slider").attr('value', 50);
        $('.ba-img.ba-foreground-img').css('width', '50%');
        $('.ba-slider-button').css('left', `calc(50% - 28px)`);
      } else if($(window).width() >= 750) {
        $("#ba-slider").attr('value', 20);
        $('.ba-img.ba-foreground-img').css('width', '20%');
        $('.ba-slider-button').css('left', `calc(20% - 28px)`);
      } else {
        $("#ba-slider").attr('value', 5);
        $('.ba-img.ba-foreground-img').css('width', '5%');
        $('.ba-slider-button').css('left', `calc(5% - 22px)`);
      }

      $(window).bind('resize', function(){
        if($(window).width() >= 990) {
          $("#ba-slider").attr('value', 50);
          $('.ba-img.ba-foreground-img').css('width', '50%');
          $('.ba-slider-button').css('left', `calc(50% - 28px)`);
        } else if($(window).width() >= 750) {
          $("#ba-slider").attr('value', 20);
          $('.ba-img.ba-foreground-img').css('width', '20%');
          $('.ba-slider-button').css('left', `calc(20% - 28px)`);
        } else {
          $("#ba-slider").attr('value', 5);
          $('.ba-img.ba-foreground-img').css('width', '5%');
          $('.ba-slider-button').css('left', `calc(5% - 22px)`);
        }
      });



      $("#ba-slider").on("input change", (e)=>{
        var sliderPos = e.target.value;
        // sliderPos = sliderPos - 1;
        // Update the width of the foreground image
        $('.ba-foreground-img').css('width', `${sliderPos}%`)
        // Update the position of the slider button
        if($(window).width() >= 750) {
          $('.ba-slider-button').css('left', `calc(${sliderPos}% - 28px)`);
        } else {
          $('.ba-slider-button').css('left', `calc(${sliderPos}% - 22px)`);
        }

      });


    }




  // DRAWERS

    $('.drawers--contents').each(function(){

      var ht;

      window.setTimeout(function () {


        var elementHeights = $('.cont-wrap').map(function() {
          return $(this).outerHeight();
        }).get();


        var ht = Math.max.apply(null, elementHeights);
        $('.drawers--left').height(ht);
        $('.drawers--contents').height(ht);

        $('.drawers--section').addClass('drawers-ready');
      }, 100);

      $(window).bind('resize', function(){
        window.setTimeout(function () {

          var elementHeights = $('.cont-wrap').map(function() {
            return $(this).outerHeight();
          }).get();
          var ht = Math.max.apply(null, elementHeights);
          $('.drawers--left').height(ht);
          $('.drawers--contents').height(ht);

        }, 100);
      });

    });

    $('[data-drawer]').on('click', function (e) {
      e.preventDefault();

      var drawer = $(this).attr('data-drawer');

      $(this).parents('div.drawer-single').addClass('active').siblings().removeClass('active');
      $('#drawer-'+drawer).addClass('active').siblings().removeClass('active');

    });


  // RESPONSIVE TABLE

    $('table.fn-table').each(function(index) {

      var tabHd;
      var tabHdTxt;
      var $td;

      $(this).find('th').each(function(index) {
        tabHd = $(this);
        tabHdTxt = tabHd.text();

        tabHd.closest('table').find('tr').each(function(index) {
          $td = $(this).find('td').eq(tabHd.index());
          $td.attr('data-th', tabHdTxt);
        });

      });

      $(this).find('tr.toreveal').hide();

    });


    $('[data-tablemore]').on('click', function (e) {
      e.preventDefault();

      var toReveal = $(this).attr("data-tablemore");

      $(this).hide();
      $('table#'+ toReveal).find('tr.toreveal').show();

    });


  // TICKER

    if($('.ticker').length) {

      $('.ticker__list').infiniteslide({
        'speed': 50,
        'direction': 'left',
        'responsive': false,
        'pauseonhover': false,
        'clone': 1
      });

    }


  // READINESS POPUP

    if($('a[href="#readiness"]').length) {
      $('a[href="#readiness"]').attr('data-fnpop', 'readiness');

      var posTop = $('a[href="#readiness"]').offset().top - 30;

      $('#pop-readiness').css('top', posTop+'px');

      $(window).bind('resize', function(){
        var posTop = $('a[href="#readiness"]').offset().top - 30;

        $('#pop-readiness').css('top', posTop+'px');
      });

    }


  // POPUPS


    $('[data-fnpop]').on('click', function (e) {
      e.preventDefault();

      var toToggle = $(this).attr("data-fnpop");

      $('#pop-'+ toToggle).addClass('active');
      // $('body').addClass('js-no-scroll').addClass('to-open');

    });


    $('[data-popclose]').on('click', function (e) {
      e.preventDefault();

      var toClose = $(this).attr('data-popclose');

      $('#'+toClose).removeClass('active');
      // $('body').removeClass('js-no-scroll').removeClass('to-open');
    });



  // MOVE TESTIMONIAL ON COLLECTION PAGE

    if($('body').hasClass('template-collection') && $('.fn-testimonialbubble').length) {

      $('.fn-testimonialbubble .bubble-testimonial').insertAfter($('.fnproduct-grid > .fngrid__item:nth-child(2)'));
      $('.bubble-testimonial').show();
    }


  // MOVE HERO TEXT ON COLLECTION PAGE ON MOBILE

    if($('body').hasClass('template-collection') && $('.hero-collection .colhero-text').length) {

      if($(window).width() < 750) {
        var textHt =  $('.hero-collection .colhero-text').outerHeight() + 100;
        $('#ProductGridContainer').css('padding-top', textHt+'px');
      } else {
        $('#ProductGridContainer').removeAttr('style');
      }

      $(window).bind('resize', function(){
        if($(window).width() < 750) {
          var textHt =  $('.hero-collection .colhero-text').outerHeight() + 100;
          $('#ProductGridContainer').css('padding-top', textHt+'px');
        } else {
          $('#ProductGridContainer').removeAttr('style');
        }
      });

    }



  // PIE CHART

    if($('.flavorchart-chart').length) {

      $('.item-prod[data-flavor-1]').hover(function(e) {

        e.preventDefault();

        var firFlavor = $(this).attr('data-flavor-1');
        var secFlavor = $(this).attr('data-flavor-2');
        var thrFlavor = $(this).attr('data-flavor-3');

        $(this).toggleClass('item-active');


        $('.flavorchart-chart path[data-hover]').attr('data-active', 'no');
        $('.flavorchart-chart path[id="chart-'+firFlavor+'"]').attr('data-active', 'yes');
        $('.flavorchart-chart path[id="chart-'+secFlavor+'"]').attr('data-active', 'yes');

        if(typeof thrFlavor !== 'undefined' && thrFlavor !== false ) {
          $('.flavorchart-chart path[id="chart-'+thrFlavor+'"]').attr('data-active', 'yes');
        }


      });
      $('.fnsection-flavorchart .prods-wrap .item-prod').mouseleave(function(e) {
        $('.flavorchart-chart path[data-hover]').removeAttr('data-active');
        $('.item-prod.item-active').removeClass('item-active');
      });





      // $('.flavorchart-chart path[data-hover]').hover(function(e) {
      //   e.preventDefault();

      //   var theFlavor = $(this).attr('data-hover');

      //   $('.flavorchart-chart path[data-hover]').attr('data-active', 'no');
      //   $(this).attr('data-active', 'yes');

      //   $('.prods-wrap').find('.item-prod.flavor-'+theFlavor).toggleClass('item-active')

      // });
      // $('.flavorchart-chart path[data-hover]').mouseleave(function(e) {
      //   $('.flavorchart-chart path[data-hover]').removeAttr('data-active');
      //   $('.item-prod.item-active').removeClass('item-active');
      // });

    }


  // TOGGLE MOBILE NAV

    $('[data-toggle="header--menu"]').on('click', function (e) {
      e.preventDefault();
      if ( $('body').hasClass('show-nav') ) {
        closeNav();
      } else {
        openNav();
      }
    });

    function openNav() {
      $('.header--menu').addClass('is-visible');
      $('body').addClass('show-nav');
      $('body').addClass('js-no-scroll');
    }

    function closeNav() {
      $('.header--menu').removeClass('is-visible');
      $('body').removeClass('show-nav');
      $('body').removeClass('js-no-scroll');
    }


    $('#mobile-cart-icon').click(function(e) {
      e.preventDefault();

      $('#cart-icon-bubble')[0].click();

    });


    // UPDATE MOBILE BAG QUANTITY
      $('#cart-icon-bubble').on('DOMSubtreeModified', function(){

        var cartCount = $(this).find('.cart-count-bubble > span:first-child').text();

        $('#mobile-cart-icon').find('.cart-count-bubble > span:first-child').text(cartCount);

      });


    $('[data-ddclose]').click(function(e){
      e.preventDefault();

      var closethis = $(this).attr('data-ddclose');

      $('.header--menu.has-hover').removeClass('has-hover');
      $('[data-menu]').parents('li.is-hover').removeClass('is-hover');

      $('#'+closethis).removeClass('dropdown-open');
      $('body').removeClass('menudropdown-open');
      $('body').removeClass('nav-hovered');
    });


    $('[data-closeall]').click(function(e){
      e.preventDefault();

      closeNav();

      $('.header--menu.has-hover').removeClass('has-hover');
      $('[data-menu]').parents('li.is-hover').removeClass('is-hover');

      $('.menu-dropdown.dropdown-open').removeClass('dropdown-open');
      $('body').removeClass('menudropdown-open');
      $('body').removeClass('nav-hovered');

    });




  // BLOG INDEX FUNCTIONS

    if($('.bloghero-wrap.hero-ftd').length) {
      var ftdlink = $('.bloghero-wrap.hero-ftd').find('.fnbtn--solid').attr('href');

      $('.articles-wrap .article-single').find('a[href="'+ftdlink+'"]').parents('.article-single').remove();

    }

    if($('.fnsection-blogindex').length && $('.articles-nav.top-nav').length) {

      if($('.articles-list > .article-single').length > 20) {

        $('.articles-list > .article-single:nth-child(20)').nextAll().addClass('noshow');
        $('.articles-list > .article-single:nth-child(20)').nextAll().hide();
        $('.articles-list + .more-cta').show();

        var noshowLength = $('.article-single.noshow').length;

        $('a[data-morearticles]').click(function(e) {
          e.preventDefault();

          $('.articles-list > .article-single.noshow').nextAll('.noshow').andSelf().slice(0,20).removeClass('noshow').show();

          noshowLength = $('.article-single.noshow').length;

          if(noshowLength == 0) {
            $('[data-morearticles]').parents('.more-cta').addClass('hide-this');
            $('[data-morearticles]').addClass('disabled').text('No more');
          }


          ScrollTrigger.refresh();

        });

      }


      // PIN NAV
      if($('.articles-nav.top-nav').length) {

        var fixedNav = $('.articles-nav.top-nav');
        var artWrap = $('.articles-wrapper');

        var navHt = fixedNav.outerHeight();
        var sectHt = artWrap.outerHeight();
        var lokHt = sectHt - navHt;


        ScrollTrigger.matchMedia({

          // desktop
          "(min-width: 750px)": function() {

            let st = ScrollTrigger.create({
              // trigger: navFor,
              pin: fixedNav,
              // start: "top top",
              // end: '+='+lokHt

              trigger: '.articles-wrapper',
              start: "top top",
              end: () => `+=${artWrap.outerHeight() - (fixedNav.outerHeight() * 2)}`
              // toggleClass: {targets: '#history-nav', className: 'active'}
            });

          },

        });

        // $('[data-hoverdrop]').hover(function(e) {
        //   ScrollTrigger.refresh();
        // });

        // $('[data-more]').each(function(index) {

        //   var toMore = $(this).attr("data-more");
        //   var wrapper = $('#'+ toMore);

        //   $(wrapper).hide();

        //   $(this).click(function(e) {
        //     e.preventDefault();

        //     if ( $(this).hasClass('is-more') ) {
        //       $(this).removeClass('is-more');
        //       $(wrapper).hide();
        //       $(wrapper).removeClass('is-visible');
        //     } else {
        //       $(this).addClass('is-more');
        //       $(wrapper).show();
        //       $(wrapper).addClass('is-visible');
        //     }


        //     ScrollTrigger.refresh();

        //   });

        // });

      }

    }


  // BLOG POST FUNCTIONS

    $.fn.findLinkMakeLink = function() {
        // Test a text node's contents for URLs and split and rebuild it with an anchor
        var testAndTag = function(el) {
            // Test for URLs along whitespace and punctuation boundaries
            var m = el.nodeValue.match(/(https?:\/\/.*?)[.!?;,]?(\s+|"|$)/);
            // If we've found a valid URL
            if (m) {
                // Clone the text node to hold the "tail end" of the split node
                var tail = $(el).clone()[0];
                // Substring the nodeValue attribute of the text nodes based on the match boundaries
                el.nodeValue = el.nodeValue.substring(0, el.nodeValue.indexOf(m[1]));
                tail.nodeValue = tail.nodeValue.substring(tail.nodeValue.indexOf(m[1]) + m[1].length);
                // Rebuild the DOM inserting the new anchor element between the split text nodes
                $(el).after(tail).after($("<span></span>").attr("class", "texturl").html(m[1]));
                // Recurse on the new tail node to check for more URLs
                testAndTag(tail);
            }
            return false;
        }
        // For each element selected by jQuery
        this.each(function() {
            // Select all descendant nodes of the element and pick out only text nodes
            var textNodes = $(this).add("*", this).contents().filter(function() {
                return this.nodeType == 3
            });
            // Take action on each text node
            $.each(textNodes, function(i, el) {
                testAndTag(el);
            });
        });
    }




    if($('.fnpost-wrapper').length && $('.articles-nav.top-nav').length) {

      // PIN NAV
      if($('.articles-nav.top-nav').length) {

        window.setTimeout(function () {


          var fixedNav = $('.articles-nav.top-nav');
          var artWrap = $('.fnpost-wrapper');

          var navHt = fixedNav.outerHeight();
          var sectHt = artWrap.outerHeight();
          var lokHt = sectHt - navHt;


          ScrollTrigger.matchMedia({

            // desktop
            "(min-width: 750px)": function() {

              let st = ScrollTrigger.create({
                // trigger: navFor,
                pin: fixedNav,
                // start: "top top",
                // end: '+='+lokHt

                trigger: '.fnpost-wrapper',
                start: "top top",
                end: () => `+=${artWrap.outerHeight() - (fixedNav.outerHeight() * 2)}`
                // toggleClass: {targets: '#history-nav', className: 'active'}
              });

            },

          });

        }, 1000);



        // $('[data-more]').each(function(index) {

        //   var toMore = $(this).attr("data-more");
        //   var wrapper = $('#'+ toMore);

        //   $(wrapper).hide();

        //   $(this).click(function(e) {
        //     e.preventDefault();

        //     if ( $(this).hasClass('is-more') ) {
        //       $(this).removeClass('is-more');
        //       $(wrapper).hide();
        //       $(wrapper).removeClass('is-visible');
        //     } else {
        //       $(this).addClass('is-more');
        //       $(wrapper).show();
        //       $(wrapper).addClass('is-visible');
        //     }


        //     ScrollTrigger.refresh();

        //   });

        // });


        // $('[data-hoverdrop]').hover(function(e) {
        //   ScrollTrigger.refresh();
        // });

      }

    }

    if($('.article-single').length) {
      $('.article-single .single-txt h2').matchHeight({byRow: true});
    }


    if($('.template-article').length) {
      $('.fnpost-content').findLinkMakeLink();
    }



  // AUTHOR PAGE

    if($('.authorpage-content').length && $('.articles-nav.top-nav').length) {

      // PIN NAV
      if($('.articles-nav.top-nav').length) {

        window.setTimeout(function () {


          var fixedNav = $('.articles-nav.top-nav');
          var artWrap = $('.authorpage-content');

          var navHt = fixedNav.outerHeight();
          var sectHt = artWrap.outerHeight();
          var lokHt = sectHt - navHt;


          ScrollTrigger.matchMedia({

            // desktop
            "(min-width: 750px)": function() {

              let st = ScrollTrigger.create({
                // trigger: navFor,
                pin: fixedNav,
                // start: "top top",
                // end: '+='+lokHt

                trigger: '.authorpage-content',
                start: "top top",
                end: () => `+=${artWrap.outerHeight() - (fixedNav.outerHeight() * 2)}`
                // toggleClass: {targets: '#history-nav', className: 'active'}
              });

            },

          });

        }, 1000);


        // $('[data-more]').each(function(index) {

        //   var toMore = $(this).attr("data-more");
        //   var wrapper = $('#'+ toMore);

        //   $(wrapper).hide();

        //   $(this).click(function(e) {
        //     e.preventDefault();

        //     if ( $(this).hasClass('is-more') ) {
        //       $(this).removeClass('is-more');
        //       $(wrapper).hide();
        //       $(wrapper).removeClass('is-visible');
        //     } else {
        //       $(this).addClass('is-more');
        //       $(wrapper).show();
        //       $(wrapper).addClass('is-visible');
        //     }


        //     ScrollTrigger.refresh();

        //   });

        // });

        // $('[data-hoverdrop]').hover(function(e) {
        //   ScrollTrigger.refresh();
        // });

      }

    }


  // GRABBING IMAGE CAPTIONS FROM ALT TEXT
    if($('.fnpost-content').length) {


      $('.fnpost-content img').each(function(index) {
        if($(this).attr('alt')) {
          var alttext = $(this).attr('alt');
          $(this).after('<span class="imgcaption">'+alttext+'</span>');
        }
      });

    }

  // PRINT RECIPES
    $('[data-print]').click(function(e){
      e.preventDefault();

      var toPrint = $(this).attr('data-print');

      $('.'+toPrint).print({
        // globalStyles: false,
        mediaPrint: true,
        // stylesheet: null,
        noPrintSelector: ".no-print",
        // iframe: true,
        // append: null,
        // prepend: null,
        // manuallyCopyFormValues: true,
        // deferred: $.Deferred(),
        // timeout: 750,
        // title: null,
        // doctype: '<!doctype html>'
      });

    });


  // HEADER SEARCH

    $('.header [data-fnsearch]').click(function(e) {
      e.preventDefault();

      $(this).next('.header-search-wrap').addClass('active');

      $('body').addClass('header-search-active');

      window.setTimeout(function () {
        // $(this).blur();
        $('form.search input#Search-In-Template').focus();
      }, 500);

    });

    $('.header-search ~ .searchbg').click(function(e) {
      e.preventDefault();

      $('.header .header-search-wrap').removeClass('active');

      $('body').removeClass('header-search-active');

    });

    $(window).scroll(function() {
      if ($('body').hasClass('header-search-active') && $(document).scrollTop() > 10) {
        $('.header .header-search-wrap').removeClass('active');
        $('body').removeClass('header-search-active');
      }
    });


  // SEARCH RESULTS

    if($('.searchitems-sections').length && $('.articles-nav.top-nav').length) {

      // PIN NAV
      if($('.articles-nav.top-nav').length) {

        window.setTimeout(function () {


          var fixedNav = $('.articles-nav.top-nav');
          var artWrap = $('.searchitems-sections');

          var navHt = fixedNav.outerHeight();
          var sectHt = artWrap.outerHeight();
          var lokHt = sectHt - navHt;


          ScrollTrigger.matchMedia({

            // desktop
            "(min-width: 750px)": function() {

              let st = ScrollTrigger.create({
                // trigger: navFor,
                pin: fixedNav,
                // start: "top top",
                // end: '+='+lokHt

                trigger: '.searchitems-sections',
                start: "top -64",
                end: () => `+=${artWrap.outerHeight() - (fixedNav.outerHeight() * 2)}`
                // toggleClass: {targets: '#history-nav', className: 'active'}
              });

            },

          });

        }, 1000);


        // $('[data-more]').each(function(index) {

        //   var toMore = $(this).attr("data-more");
        //   var wrapper = $('#'+ toMore);

        //   $(wrapper).hide();

        //   $(this).click(function(e) {
        //     e.preventDefault();

        //     if ( $(this).hasClass('is-more') ) {
        //       $(this).removeClass('is-more');
        //       $(wrapper).hide();
        //       $(wrapper).removeClass('is-visible');
        //     } else {
        //       $(this).addClass('is-more');
        //       $(wrapper).show();
        //       $(wrapper).addClass('is-visible');
        //     }


        //     ScrollTrigger.refresh();

        //   });

        // });

        // $('[data-hoverdrop]').hover(function(e) {
        //   ScrollTrigger.refresh();
        // });

      }

    }


  var bLazy = new Blazy({
    offset: 600,
    loadInvisible: true,
    success: function(ele){
      $(ele).parent().addClass('child-loaded');
      $.fn.matchHeight._update();
    }
  });

});